import { List, ListItemButton, ListItemText, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectEvents } from "../store/events";

function EventPreview({ event }) {
  let time = event.startdate.slice(11, 16) + " ";
  if (time === "00:00 ") time = "";
  return (
    <ListItemButton onClick={() => window.open(event.url, "_blank")}>
      <div
        style={{
          flexGrow: 0,
          flexShrink: 0,
          display: "inline-block",
          margin: 0,
          height: 70,
          width: 70,
          backgroundImage: `url(${event.image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: 8,
        }}
      >
        <Typography
          sx={{
            fontSize: 9,
            position: "absolute",
            left: 18,
            width: 68,
            top: 66,
            color: "white",
            textAlign: "center",
            textShadow: " 0 0 2px black, 0 0 1px black ",
          }}
        >
          {event.source}
        </Typography>
      </div>
      <Typography
        component="div"
        variant="body1"
        sx={{
          marginTop: 0,
          marginLeft: 2,
          marginBottom: 0,
          padding: 0,
          height: 70,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <small>
          <strong>{time}</strong>
        </small>
        {event.name}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: 35,
            backgroundImage: "linear-gradient(rgba(255,255,255,0), white)",
          }}
        ></div>
        <div style={{ fontSize: "75%" }}>{event.description}</div>
      </Typography>
    </ListItemButton>
  );
}

function DateHeader({ date }) {
  let today = new Date().toISOString().slice(0, 10);
  let tomorrow = new Date(Date.now() + 24 * 60 * 60 * 1000)
    .toISOString()
    .slice(0, 10);
  let days = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(
    " "
  );
  let d = new Date(date);
  return (
    <ListItemText sx={{ marginTop: 4, marginLeft: 2, marginBottom: -0.5 }}>
      <Typography variant="h5">
        {today === date ? "Today, " : ""}
        {tomorrow === date ? "Tomorrow, " : ""}
        {days[d.getDay()]} {"\xa0"}
        <small>
          {d.getDate()}/{d.getMonth() + 1}
        </small>
      </Typography>
    </ListItemText>
  );
}
export function Calendar() {
  let events = useSelector(selectEvents);
  let items = [];
  let prevDate = events[0]?.startdate?.slice(0, 10);
  if (events.length) items.push(<DateHeader key={prevDate} date={prevDate} />);
  for (const event of events) {
    let date = event.startdate.slice(0, 10);
    if (date !== prevDate) {
      items.push(<DateHeader key={date} date={date} />);
      prevDate = date;
    }
    items.push(<EventPreview key={event.id} event={event} />);
  }
  return <div>
      <Typography variant="body1"><br/>
      Calendar – currently just containing events from KU<br/>
      Filtering and other sources to be added later.</Typography>
  <List sx={{ textAlign: "left" }}>{items}</List>
</div>
}

function EventRow({ events }) {
  return (
    <div style={{ whiteSpace: "nowrap", position: "relative" }}>
      <div
        style={{
          position: "absolute",
          display: "inline-block",
          right: 0,
          top: 0,
          bottom: 0,
          width: 100,
          zIndex: 1,
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,0), white)",
        }}
      ></div>
      {events.map((event) => (
        <div
          key={event.id}
          style={{
            whiteSpace: "normal",
            position: "relative",
            display: "inline-block",
            fontSize: 12,
            lineHeight: 1.2,
            height: 48,
            width: 120,
            borderRadius: 4,
            marginRight: 8,
            fontWeight: "bold",
            overflow: "hidden",
            textShadow:
              "0px 0px 2px white, 0px 0px 4px white, 0px 0px 8px white",
          }}
        >
          <div
            style={{
              paddingTop: 4,
              paddingLeft: 8,
              height: "100%",
              background: "rgba(255,255,255,0.4)",
            }}
          >
            {event.name}
          </div>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `url(${event.image})`,
              backgroundSize: "cover",
              zIndex: -1,
            }}
          ></div>
        </div>
      ))}
    </div>
  );
}
export function MiniCalendar() {
  let events = useSelector(selectEvents);
  return (
    <Typography
      component="div"
      sx={{
        overflow: "hidden",
      }}
    >
      <EventRow events={events.filter((_, i) => !(i % 2))} />
      <EventRow events={events.filter((_, i) => i % 2)} />
    </Typography>
  );
}
